import { connect } from 'react-redux';
import { compose, lifecycle, renderNothing } from 'recompose';
import { userIsAuthenticatedRedirWithoutRedirectBack } from 'components/auth/hoc';
import { actions } from 'state/auth';

const enhance = compose(
  connect(null, {
    logout: actions.logout,
  }),
  lifecycle({
    componentDidMount() {
      const { logout } = this.props;

      logout();
    },
  }),
  userIsAuthenticatedRedirWithoutRedirectBack,
  renderNothing
);

const Logout = () => null;

export default enhance(Logout);
